(() => {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  const publishedRanch75Events = new Set();
  const firstPourPendingKey = 'r75FirstPourSignupPending';

  function safeSessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Storage is optional; Shopify's native form still owns subscriber capture.
    }
  }

  function safeSessionRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Storage is optional; Shopify's native form still owns subscriber capture.
    }
  }

  function publishRanch75Event(name, payload = {}) {
    if (!window.Shopify?.analytics || typeof window.Shopify.analytics.publish !== 'function') return;

    window.Shopify.analytics.publish(name, {
      page_path: window.location.pathname,
      page_url: window.location.href,
      ...payload,
    });
  }

  function publishRanch75EventOnce(name, payload = {}, key = name) {
    if (publishedRanch75Events.has(key)) return;
    publishedRanch75Events.add(key);
    publishRanch75Event(name, payload);
  }

  function trackFirstPourMetaLead() {
    if (typeof window.fbq !== 'function') return;

    window.fbq('track', 'Lead', {
      content_name: 'First Pour Signup',
      content_category: 'email_signup',
    });
  }

  function firstPourRoute() {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    if (path === '/pages/firstpour' || path === '/firstpour') return 'landing';
    if (path === '/pages/firstpour-success' || path === '/firstpour/success') return 'success';
    return null;
  }

  function initMobileMenus(scope = document) {
    scope.querySelectorAll('.mobile-menu-toggle').forEach((button) => {
      if (button.dataset.r75Bound === 'true') return;
      button.dataset.r75Bound = 'true';
      button.addEventListener('click', () => {
        const nav = button.closest('nav');
        if (!nav) return;
        const isOpen = nav.classList.toggle('mobile-menu-open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    scope.querySelectorAll('nav .nav-links a, .r75-site-nav .r75-nav-links a').forEach((link) => {
      if (link.dataset.r75NavBound === 'true') return;
      link.dataset.r75NavBound = 'true';
      link.addEventListener('click', () => {
        const nav = link.closest('nav');
        if (!nav) return;
        const button = nav.querySelector('.mobile-menu-toggle');
        nav.classList.remove('mobile-menu-open');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initAgeGate(scope = document) {
    const gate = scope.querySelector('#age-gate') || document.getElementById('age-gate');
    if (!gate) return;
    const enter = gate.querySelector('[data-age-enter]');
    const leave = gate.querySelector('[data-age-leave]');

    const openSite = () => {
      gate.style.display = 'none';
      document.body.classList.add('age-cleared');
      safeSessionSet('ageVerified', 'true');
    };

    if (safeSessionGet('ageVerified') === 'true') {
      gate.style.display = 'none';
      document.body.classList.add('age-cleared');
    }

    if (enter && enter.dataset.r75Bound !== 'true') {
      enter.dataset.r75Bound = 'true';
      enter.addEventListener('click', openSite);
    }
    if (leave && leave.dataset.r75Bound !== 'true') {
      leave.dataset.r75Bound = 'true';
      leave.addEventListener('click', () => { window.location.href = 'https://www.google.com'; });
    }
  }

  function syncFaqWidth() {
    const h2 = document.querySelector('#faq h2');
    const inner = document.querySelector('.faq-inner');
    const faq = document.getElementById('faq');
    if (!h2 || !inner || !faq) return;

    h2.style.fontSize = '';
    inner.style.width = '';
    inner.style.maxWidth = '';

    const desktopFaq = window.matchMedia('(min-width: 1181px)').matches;
    const sizingTarget = desktopFaq ? document.querySelector('.faq-content') : faq;
    if (!sizingTarget) return;

    const faqStyles = window.getComputedStyle(sizingTarget);
    const availableWidth = Math.max(0, sizingTarget.clientWidth - parseFloat(faqStyles.paddingLeft) - parseFloat(faqStyles.paddingRight));
    const range = document.createRange();
    range.selectNodeContents(h2);
    let headingWidth = Math.ceil(range.getBoundingClientRect().width);

    if (headingWidth > availableWidth) {
      const baseSize = parseFloat(window.getComputedStyle(h2).fontSize);
      const fittedSize = Math.max(36, Math.floor(baseSize * (availableWidth / headingWidth)));
      h2.style.fontSize = fittedSize + 'px';
      headingWidth = Math.ceil(range.getBoundingClientRect().width);
    }

    const w = Math.min(headingWidth, availableWidth);
    if (!desktopFaq && w > 0) {
      inner.style.width = w + 'px';
      inner.style.maxWidth = '100%';
    }
  }

  function syncDesktopFaqHeight() {
    const faq = document.getElementById('faq');
    const content = document.querySelector('.faq-content');
    if (!faq || !content) return;

    content.style.minHeight = '';

    if (!window.matchMedia('(min-width: 1181px)').matches) return;

    const clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.inset = '0 auto auto -9999px';
    clone.style.width = content.getBoundingClientRect().width + 'px';
    clone.style.minHeight = '';

    clone.querySelectorAll('.faq-answer').forEach((answer) => {
      answer.style.transition = 'none';
    });

    faq.appendChild(clone);

    const items = Array.from(clone.querySelectorAll('.faq-item'));
    items.forEach((item) => item.classList.remove('open'));
    let stableHeight = clone.getBoundingClientRect().height;

    items.forEach((item) => {
      items.forEach((el) => el.classList.remove('open'));
      item.classList.add('open');
      stableHeight = Math.max(stableHeight, clone.getBoundingClientRect().height);
    });

    items.forEach((openingItem, openingIndex) => {
      items.forEach((closingItem, closingIndex) => {
        if (openingIndex === closingIndex) return;
        items.forEach((el) => el.classList.remove('open'));
        openingItem.classList.add('open');
        closingItem.classList.add('open');
        stableHeight = Math.max(stableHeight, clone.getBoundingClientRect().height);
      });
    });

    clone.remove();

    if (stableHeight > 0) {
      content.style.minHeight = Math.ceil(stableHeight) + 'px';
    }
  }

  function syncFaqLayout() {
    syncFaqWidth();
    syncDesktopFaqHeight();
  }

  function initFaq(scope = document) {
    scope.querySelectorAll('.faq-question').forEach((button) => {
      if (button.dataset.r75Bound === 'true') return;
      button.dataset.r75Bound = 'true';
      button.addEventListener('click', () => {
        const item = button.closest('.faq-item');
        if (!item) return;
        syncDesktopFaqHeight();
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach((el) => {
          el.classList.remove('open');
          const q = el.querySelector('.faq-question');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
        } else {
          button.setAttribute('aria-expanded', 'false');
        }
      });
    });
    syncFaqLayout();
  }

  function syncDesktopStoryPanel(chapter) {
    const panel = document.querySelector('.clean-story-desktop-panel');
    if (!panel) return;
    const activeChapter = chapter || document.querySelector('.clean-story-chapter.open');
    const source = activeChapter && activeChapter.querySelector('.clean-story-body');
    if (!source) return;
    panel.innerHTML = source.innerHTML;
    fitStoryPanelHeading(panel);
  }

  function fitStoryPanelHeading(panel) {
    const heading = panel.querySelector('.clean-story-panel-heading');
    if (!heading || !window.matchMedia('(min-width: 1181px)').matches) return;
    heading.style.fontSize = '56px';
    const availableWidth = panel.clientWidth;
    const range = document.createRange();
    range.selectNodeContents(heading);
    const headingWidth = range.getBoundingClientRect().width;
    if (headingWidth > availableWidth) {
      const fittedSize = Math.max(34, Math.floor(56 * (availableWidth / headingWidth)));
      heading.style.fontSize = fittedSize + 'px';
    }
  }

  function initStory(scope = document) {
    scope.querySelectorAll('.clean-story-toggle').forEach((button) => {
      if (button.dataset.r75Bound === 'true') return;
      button.dataset.r75Bound = 'true';
      button.addEventListener('click', () => {
        const chapter = button.closest('.clean-story-chapter');
        if (!chapter) return;
        document.querySelectorAll('.clean-story-chapter.open').forEach((el) => {
          if (el !== chapter) {
            el.classList.remove('open');
            const toggle = el.querySelector('.clean-story-toggle');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          }
        });
        chapter.classList.add('open');
        button.setAttribute('aria-expanded', 'true');
        syncDesktopStoryPanel(chapter);
      });
    });
    syncDesktopStoryPanel();
  }

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function initFirstPourForms(scope = document) {
    scope.querySelectorAll('.first-pour-native-form').forEach((form) => {
      if (form.dataset.r75Bound === 'true') return;
      form.dataset.r75Bound = 'true';
      form.noValidate = true;
      form.addEventListener('submit', (event) => {
        const firstName = form.querySelector('[name="contact[first_name]"]');
        const email = form.querySelector('[name="contact[email]"]');
        const msg = form.querySelector('.firstpour-message') || form.closest('.newsletter')?.querySelector('.newsletter-message');
        const button = form.querySelector('button[type="submit"]');

        if (firstName && !firstName.value.trim()) {
          event.preventDefault();
          if (msg) {
            msg.textContent = 'Please enter your first name.';
            msg.className = msg.className.replace(/\s?(success|error)\b/g, '') + ' error';
          }
          firstName.focus();
          return;
        }

        if (firstName && emailPattern.test(firstName.value.trim())) {
          event.preventDefault();
          if (msg) {
            msg.textContent = 'Please enter your first name, not your email address.';
            msg.className = msg.className.replace(/\s?(success|error)\b/g, '') + ' error';
          }
          firstName.focus();
          return;
        }

        if (!email || !emailPattern.test(email.value.trim())) {
          event.preventDefault();
          if (msg) {
            msg.textContent = 'Please enter a valid email address.';
            msg.className = msg.className.replace(/\s?(success|error)\b/g, '') + ' error';
          }
          if (email) email.focus();
          return;
        }

        if (firstName) firstName.value = firstName.value.trim();
        email.value = email.value.trim();

        if (msg) {
          msg.textContent = '';
          msg.className = msg.className.replace(/\s?(success|error)\b/g, '');
        }

        if (form.classList.contains('firstpour-form')) {
          safeSessionSet(firstPourPendingKey, 'true');
        }

        if (button) {
          button.disabled = true;
          if (form.classList.contains('firstpour-form')) {
            button.innerHTML = '<span class="firstpour-spinner" aria-hidden="true"></span>Getting Access';
          } else {
            button.textContent = 'Joining...';
          }
        }
      });
    });
  }

  function initRanch75Events(scope = document) {
    const route = firstPourRoute();

    if (route === 'landing') {
      safeSessionRemove(firstPourPendingKey);
      publishRanch75EventOnce('ranch75:first_pour_landing_page_view', { first_pour_route: route }, 'first_pour_landing_page_view');
    }

    if (route === 'success') {
      publishRanch75EventOnce('ranch75:first_pour_success_page_view', { first_pour_route: route }, 'first_pour_success_page_view');

      if (safeSessionGet(firstPourPendingKey) === 'true') {
        publishRanch75EventOnce(
          'ranch75:first_pour_signup_success',
          { signup_source: 'first_pour', first_pour_route: route },
          'first_pour_signup_success'
        );
        trackFirstPourMetaLead();
        safeSessionRemove(firstPourPendingKey);
      }
    }

    scope.querySelectorAll('[data-r75-event]').forEach((element) => {
      if (element.dataset.r75EventBound === 'true') return;
      element.dataset.r75EventBound = 'true';
      element.addEventListener('click', () => {
        publishRanch75Event(element.dataset.r75Event, {
          location: element.dataset.r75Location || '',
          social_network: element.dataset.r75Social || '',
          link_url: element.href || '',
        });
      });
    });

    scope.querySelectorAll('[data-r75-event-on-load]').forEach((element) => {
      const eventName = element.dataset.r75EventOnLoad;
      const eventKey = `${eventName}:${window.location.pathname}:${element.id || element.dataset.r75SignupSource || 'load'}`;
      publishRanch75EventOnce(eventName, {
        signup_source: element.dataset.r75SignupSource || '',
      }, eventKey);
    });
  }

  function initPendingLinks(scope = document) {
    scope.querySelectorAll('[data-r75-pending-url]').forEach((link) => {
      if (link.dataset.r75Bound === 'true') return;
      link.dataset.r75Bound = 'true';
      link.addEventListener('click', (event) => {
        if (!link.getAttribute('href') || link.getAttribute('href') === '#') event.preventDefault();
      });
    });
  }

  function initRanch75(scope = document) {
    initMobileMenus(scope);
    initAgeGate(scope);
    initFaq(scope);
    initStory(scope);
    initFirstPourForms(scope);
    initRanch75Events(scope);
    initPendingLinks(scope);
  }

  ready(() => initRanch75(document));
  window.addEventListener('load', () => { syncFaqLayout(); syncDesktopStoryPanel(); });
  window.addEventListener('resize', () => { syncFaqLayout(); syncDesktopStoryPanel(); });

  document.addEventListener('shopify:section:load', (event) => initRanch75(event.target));
  document.addEventListener('shopify:section:select', (event) => initRanch75(event.target));
})();
